module.exports = __webpack_public_path__ + "images/FUSA_icons/049-shopping-bag-3.05333a4a6dc05818f538ef8042b709db.svg";